import React from 'react';
import { ReactComponent as PhoneIcon } from 'assets/images/criticalIncident/telephone.svg';
import { ReactComponent as VideoIcon } from 'assets/images/criticalIncident/video_camera.svg';
import { ReactComponent as UserIcon } from 'assets/images/criticalIncident/user_icon.svg';
import SvgIcon from '@mui/material/SvgIcon';
import { 
    IN_PERSON,
    IN_PERSON_COUNSELLING_MODALITY_CODE, 
    IN_PERSON_SPACED, 
    ONLINE, 
    TELE_COUNSELLING, 
    TELE_COUNSELLING_MODALITY_CODE, 
    TELEPHONIC, 
    VIDEO_COUNSELLING, 
    VIDEO_COUNSELLING_MODALITY_CODE,
    VIRTUAL,
    VIDEO
} from 'constants/modalities';

export const renderEventMatchingIcon = (modalityCode: string, className = '') => {
    switch(modalityCode?.toUpperCase()) {
        case ONLINE:
        case VIRTUAL:
        case VIDEO:
        case VIDEO_COUNSELLING:
        case VIDEO_COUNSELLING_MODALITY_CODE:
            return <SvgIcon component={VideoIcon} inheritViewBox className={className} />;
        case TELEPHONIC:
        case TELE_COUNSELLING:
        case TELE_COUNSELLING_MODALITY_CODE:
            return <SvgIcon component={PhoneIcon} inheritViewBox className={className} />;
        case IN_PERSON_SPACED:
        case IN_PERSON:
        case IN_PERSON_COUNSELLING_MODALITY_CODE:
            return <SvgIcon component={UserIcon} inheritViewBox className={className} />;
        default:
            return '';
    }
}
